if (!customElements.get('soera-sticky-cart')) {
  class SoeraStickyCart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
      this.picker = this.section?.querySelector('.js-product variant-picker');
      this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
      this.selects = [...this.querySelectorAll('[data-sticky-option]')];
      this.input = this.querySelector('[name="id"]');
      this.button = this.querySelector('[name="add"]');
      this.image = this.querySelector('[data-sticky-image]');
      this.trackPreviewBar();
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-sticky-option]')) return;
        this.selectVariant(Number(event.target.dataset.optionIndex));
      });
      this.section?.addEventListener('on:variant:change', event => {
        this.updateVariant(event.detail.variant, event.detail.selectedOptions);
      });
      if (this.picker?.getSelectedVariant) {
        this.updateVariant(this.picker.getSelectedVariant(), this.picker.getSelectedOptions());
      }
      const reviewLink = this.querySelector('[data-sticky-reviews]');
      reviewLink?.addEventListener('click', event => {
        const reviews = document.querySelector('#looxReviews, #looxReviewsFrame');
        if (!reviews) return;
        event.preventDefault();
        reviews.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      });
    }
    trackPreviewBar() {
      const findFrame = () => {
        const frame = document.getElementById('PBarNextFrame') || document.getElementById('preview-bar-iframe');
        if (!frame) return false;
        const toolbar = document.getElementById('PBarNextFrameWrapper') || frame;
        const updateOffset = () => {
          const rect = toolbar.getBoundingClientRect();
          const offset = rect.width && rect.height ? Math.max(0, innerHeight - rect.top) : 0;
          this.style.setProperty('--soera-preview-offset', `${offset}px`);
        };
        new ResizeObserver(updateOffset).observe(toolbar);
        window.addEventListener('resize', updateOffset);
        updateOffset();
        return true;
      };
      if (findFrame()) return;
      if (window.Shopify?.theme?.role !== 'unpublished' && !new URLSearchParams(location.search).has('preview_theme_id')) return;
      const observer = new MutationObserver(() => {if (findFrame()) observer.disconnect();});
      observer.observe(document.body, {childList: true, subtree: true});
    }
    selectVariant(changedIndex) {
      const options = this.selects.map(select => select.value);
      if (this.picker) {
        const selectors = [...this.picker.querySelectorAll('.option-selector:not(.option-selector--custom)')];
        selectors.forEach((selector, index) => {
          if (selector.dataset.selectorType === 'dropdown') {
            const custom = selector.querySelector('custom-select');
            const option = [...selector.querySelectorAll('.custom-select__option')].find(el => el.dataset.value === options[index]);
            if (custom?.selectOption && option) custom.selectOption(option);
          } else {
            const input = [...selector.querySelectorAll('input')].find(el => el.value === options[index]);
            if (input) input.checked = true;
          }
        });
        const changedSelector = selectors[changedIndex];
        const changedInput = changedSelector?.querySelector('input:checked');
        if (changedInput) changedInput.dispatchEvent(new Event('change', {bubbles: true}));
        else if (changedSelector) this.picker.handleVariantChange({type: 'change', target: changedSelector});
      }
      const variant = this.variants.find(item => item.options.every((value, index) => value === options[index]));
      this.updateVariant(variant, options);
    }
    updateVariant(variant, selectedOptions) {
      const data = variant && this.variants.find(item => item.id === variant.id);
      this.input.value = data ? data.id : '';
      this.button.disabled = !data?.available;
      const label = this.querySelector('[data-sticky-button-label]');
      if (label) label.textContent = data?.available ? this.dataset.addText : data ? this.dataset.soldOutText : this.dataset.unavailableText;
      if (selectedOptions) this.selects.forEach((select, index) => { select.value = selectedOptions[index] || ''; });
      if (!data) return;
      this.querySelector('[data-sticky-price]').innerHTML = data.price;
      const compare = this.querySelector('[data-sticky-compare]');
      compare.innerHTML = data.compare;
      compare.hidden = !data.compare;
      if (this.image && data.image) {
        this.image.src = data.image;
        this.image.removeAttribute('srcset');
      }
    }
  }
  customElements.define('soera-sticky-cart', SoeraStickyCart);
}
